import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity } from 'src/app/services/servicio-formato-asistencial.service';
import { AyudaDiagnosticaEntity, FormulaMedicaEntity, IncapacidadEntity, ServicioAyudasDxService } from 'src/app/services/servicio-ayudas-dx.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-ayudas-diagnosticas',
  templateUrl: './ayudas-diagnosticas.component.html',
  styleUrls: ['./ayudas-diagnosticas.component.css']
})
export class AyudasDiagnosticasComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() mode: string;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  incapacidades: IncapacidadEntity[] = [];
  medicamentos: FormulaMedicaEntity[] = [];
  procedimientos: AyudaDiagnosticaEntity[] = [];

  constructor( private servicioAyudaDx: ServicioAyudasDxService) { }

  ngOnInit() {
    this.getAyudasDiagnosticas();
    this.getFormulasMedicas();
    this.getIncapacidades();
  }

  async getAyudasDiagnosticas() {
    const promise = await this.servicioAyudaDx.getAyudasDiagnosticasTTA(this.filtros.codigoBaseDatos, this.filtros.tta);
    if(promise) {
      promise.subscribe((list: AyudaDiagnosticaEntity[]) => {
        this.procedimientos = list;
      }, (err: HttpErrorResponse) => {
        this.procedimientos = [];
        console.error('Error getAyudasDiagnosticas()', err);
      })
    }
  }

  async getFormulasMedicas() {
    const promise = await this.servicioAyudaDx.getFormulacionMedicaTTA(this.filtros.codigoBaseDatos, this.filtros.tta);
    if (promise) {
      promise.subscribe((list: FormulaMedicaEntity[]) => {
        this.medicamentos = list;
      }, (err: HttpErrorResponse) => {
        this.medicamentos = [];
        console.error('Error getFormulasMedicas()', err);
      })
    }
  }

  async getIncapacidades() {
    const promise = await this.servicioAyudaDx.getIncapacidadesTTA(this.filtros.codigoBaseDatos, this.filtros.tta);
    if (promise) {
      promise.subscribe((list: IncapacidadEntity[]) => {
        this.incapacidades = list;
      }, (err: HttpErrorResponse) => {
        this.incapacidades = [];
        console.error('Error getIncapacidades()', err);
      })
    }
  }

  isTableMode(): boolean {
    return !this.mode || this.mode.length === 0 || this.mode === 'table';
  }

  isTextMode(): boolean {
    return this.mode && this.mode.length > 0 && this.mode === 'text';
  }

}
